import React from "react";
import { useTranslation } from "react-i18next";
import DocList from "./DocList";

// Retailer -- matches Diamond-PO-Prototype-v3.html's r-memos screen (line 800).
export const MyMemos = () => {
  const { t } = useTranslation();
  return <DocList title={t("My Memos")} description={t("Stones consigned to you")} kind="MEMO" whoColumn={t("Supplier")} whoField="SupplierName" />;
};

export default MyMemos;
